import {
  UMC_SUMBIT_PAYMENT,
  HIDE_ALERT_INFO_SUBMIT_FAIL,
  CANCEL_REDIRECT_TO_PAYMENT_SUPPORT_PAGE
} from "./types";

export const submitPayment = () => {
  return {
    type: UMC_SUMBIT_PAYMENT
  };
};

export const resetAlertSubmitFail = () => {
  return {
    type: HIDE_ALERT_INFO_SUBMIT_FAIL
  };
};

export const cancelRedirectToPaymentSupportPage = () => {
  return {
    type: CANCEL_REDIRECT_TO_PAYMENT_SUPPORT_PAGE
  };
};
